var GIFT_CARD_PROMO = (function() {
  var config = {
    enabled: false,
    tiers: []
  };
  var promoContainer = null;
  var isUpdating = false;

  var log = function() {
    // console.log.apply(console, ['[GIFT_CARD_PROMO]', ...arguments]);
  };

  var init = function() {
    readConfig();
    promoContainer = document.getElementById('gift_card_promo_display');
    if (!config.enabled || !promoContainer) return;

    // Attach event listeners
    if (window.jQuery) {
      jQuery(document).on('cart.requestComplete', function(event, cart) {
        handleCartChange();
      });
    }

    // Initial check
    if (window.CartJS && CartJS.cart) {
      handleCartChange();
    }
  };


  var readConfig = function() {
    try {
      var script = document.getElementById('gift-card-promo-data');
      if (script && script.textContent) {
        var data = JSON.parse(script.textContent);
        config.enabled = data.enabled;

        // Parse localized strings to update thresholds
        var tiers = (data.tiers || []);
        tiers.forEach(function(t) {
            if (t.min_spend_str) {
                // Strip everything except digits
                // This works for decimal currencies and JPY as long as formatting includes decimals
                // e.g. £118.50 -> 11850
                // ¥15000 -> 15000
                var numeric = t.min_spend_str.replace(/[^0-9]/g, '');
                if (numeric && numeric.length > 0) t.min_spend = parseInt(numeric, 10);
            }
            if (t.card_value_str) {
                 t.formatted_card_value = t.card_value_str;
                 var numeric = t.card_value_str.replace(/[^0-9]/g, '');
                 if (numeric && numeric.length > 0) t.card_value = parseInt(numeric, 10);
            }

            // Fix variant_id if it's a GID
            if (t.variant_id && String(t.variant_id).indexOf('gid://') !== -1) {
                var parts = String(t.variant_id).split('/');
                t.variant_id = parts.pop();
            }
        });

        // Sort tiers by min_spend ascending
        config.tiers = tiers.sort(function(a, b) {
          return a.min_spend - b.min_spend;
        });
      }
    } catch (e) {
      log('Error reading config', e);
    }
  };

  var getCartSubtotal = function() {
    if (!window.CartJS || !CartJS.cart) return 0;
    var items = CartJS.cart.items || [];
    var subtotal = 0;

    // Calculate subtotal excluding:
    // 1. Promo gift cards defined in tiers (by variant_id)
    // 2. Regular gift cards (item.gift_card === true) - prevents promo exploitation
    var tierVariantIds = config.tiers.map(function(t) { return String(t.variant_id); });

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      // Skip promo gift cards
      if (tierVariantIds.indexOf(String(item.variant_id)) !== -1) continue;
      // Skip regular gift cards (closes loophole - can't buy gift cards to earn promo gift cards)
      if (item.gift_card) continue;
      subtotal += item.final_line_price;
    }

    // Re-calculating loop with original_line_price if final_line_price failed or wasn't sufficient
    // Logic: tier discounts usually apply to subtotal before other discounts?
    // But we want to be safe and use what the customer pays or value of items.
    // Let's stick to the previous logic which was summing original_line_price
    subtotal = 0;
    for (var j = 0; j < items.length; j++) {
      var it = items[j];
      // Skip promo gift cards
      if (tierVariantIds.indexOf(String(it.variant_id)) !== -1) continue;
      // Skip regular gift cards
      if (it.gift_card) continue;
      subtotal += (it.original_line_price || it.line_price);
    }

    return subtotal;
  };

  var getEligibleTier = function(subtotal) {
    var eligible = null;
    for (var i = config.tiers.length - 1; i >= 0; i--) {
      var tier = config.tiers[i];
      if (subtotal >= tier.min_spend) {
        eligible = tier;
        break;
      }
    }
    return eligible;
  };

  var getNextTier = function(subtotal) {
    for (var i = 0; i < config.tiers.length; i++) {
      var tier = config.tiers[i];
      if (subtotal < tier.min_spend) {
        return tier;
      }
    }
    return null;
  };

  var findGiftCardInCart = function() {
    if (!window.CartJS || !CartJS.cart) return null;
    var items = CartJS.cart.items || [];
    var tierVariantIds = config.tiers.map(function(t) { return String(t.variant_id); });

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (tierVariantIds.indexOf(String(item.variant_id)) !== -1) {
        return item;
      }
    }
    return null;
  };

  var formatMoney = function(cents) {
    // Try to use Shopify.formatMoney with theme format
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        var format = (typeof HAYABUSA_HELPER !== 'undefined' && HAYABUSA_HELPER.mnfmt) ? HAYABUSA_HELPER.mnfmt : null;
        if (!format && window.ShopCurrency && window.ShopCurrency.format) format = window.ShopCurrency.format;

        if (format) return Shopify.formatMoney(cents, format);
    }
    // Fallback
    return '$' + (cents / 100).toFixed(2);
  };

  var renderUI = function(tier, hasCardInCart, subtotal) {
    var banner = document.getElementById('gift-card-promo-banner');

    if (banner) {
        banner.style.display = 'block';
        updateBannerUI(tier, hasCardInCart, subtotal);
    }

    if (!promoContainer) return;

    var nextTier = getNextTier(subtotal);
    var html = '';

    if (tier) {
        // Eligible for a tier
        html += '<div class="gift-card-promo-box">';
        if (hasCardInCart) {
            html += '<p class="gift-card-promo-text">You have unlocked the Gift Card!</p>';
            html += '<span class="gift-card-promo-active">Included in Cart</span>';
        } else {
            var valueDisplay = tier.formatted_card_value || formatMoney(tier.card_value);
            html += '<p class="gift-card-promo-text">You are eligible for a ' + valueDisplay + ' Gift Card!</p>';
            html += '<button class="gift-card-promo-action" onclick="GIFT_CARD_PROMO.addGiftCard(' + tier.variant_id + ')">Claim ' + valueDisplay + ' Gift Card</button>';
            html += '<a href="#" data-toggle="modal" data-target="#giftCardPromoTerms" style="display:block; margin-top: 8px; font-size: 11px; text-decoration: underline; color: #ccc;">See terms and conditions</a>';
        }
        html += '</div>';

        // Also show progress to NEXT tier if any
        if (nextTier) {
             var remaining = nextTier.min_spend - subtotal;
             // Prevent negative remaining if floating point glitch (though integers are used)
             if (remaining < 0) remaining = 0;
             var remainingDisplay = formatMoney(remaining);
             var nextValueDisplay = nextTier.formatted_card_value || formatMoney(nextTier.card_value);
             html += '<div class="gift-card-promo-progress" style="margin-top:5px; font-size:12px; color:#999;">';
             html += 'Add ' + remainingDisplay + ' to receive a ' + nextValueDisplay + ' gift card!';
             html += '</div>';
        }

    } else if (nextTier) {
        // Not eligible yet, show progress to first tier
        var remaining = nextTier.min_spend - subtotal;
        if (remaining < 0) remaining = 0;
        var remainingDisplay = formatMoney(remaining);
        var nextValueDisplay = nextTier.formatted_card_value || formatMoney(nextTier.card_value);

        html += '<div class="gift-card-promo-box">';
        html += '<p class="gift-card-promo-text" style="font-weight:400; font-size:12px;">Add ' + remainingDisplay + ' to receive a <span style="color:#FFD700; font-weight:700;">' + nextValueDisplay + ' gift card!</span></p>';
        html += '</div>';
    } else {
        // No tiers or config issue
        promoContainer.style.display = 'none';
        promoContainer.innerHTML = '';
        return;
    }

    promoContainer.innerHTML = html;
    promoContainer.style.display = 'block';
  };

  var updateBannerUI = function(activeTier, hasCardInCart, subtotal) {
    // Calculate max spend for progress bar
    var maxSpend = 0;
    if (config.tiers.length > 0) {
       maxSpend = config.tiers[config.tiers.length - 1].min_spend;
    }

    // Update Progress Bar
    var percent = 0;
    if (maxSpend > 0) {
       percent = (subtotal / maxSpend) * 100;
       if (percent > 100) percent = 100;
    }

    var fills = document.querySelectorAll('.gc-progress-fill');
    for (var i=0; i<fills.length; i++) {
       fills[i].style.width = percent + '%';
    }

    // Update Tiers
    var tierItems = document.querySelectorAll('.gc-tier-item, .gc-tier-mobile-item');

    for (var i=0; i<tierItems.length; i++) {
       var el = tierItems[i];
       var min = parseInt(el.getAttribute('data-min-spend'), 10);

       var tierConfig = null;
       for(var k=0; k<config.tiers.length; k++) {
           // Exact match preferred, but handle potential float diffs if any
           if(Math.abs(config.tiers[k].min_spend - min) < 2) {
                tierConfig = config.tiers[k];
                break;
           }
       }

       // Active State
       if (subtotal >= min) {
           el.classList.add('active');
           // Removed click handler assignment as per request to disable adding from banner
           // el.style.cursor = 'pointer';
           // if (tierConfig) { ... }
           el.style.cursor = 'default';
           el.onclick = null;
       } else {
           el.classList.remove('active');
           el.style.cursor = 'default';
           el.onclick = null;
       }
    }

    // Mobile Status Text
    var mobileText = document.querySelector('.gc-mobile-status-text');
    if (mobileText) {
        var nextTier = getNextTier(subtotal);
        if (nextTier) {
            var rem = nextTier.min_spend - subtotal;
            if (rem < 0) rem = 0;
            var valDisplay = nextTier.formatted_card_value || formatMoney(nextTier.card_value);
            mobileText.innerHTML = 'Add ' + formatMoney(rem) + ' to unlock <span style="color:#FFD700;font-weight:bold;">' + valDisplay + ' Gift Card</span>';
        } else if (activeTier) {
            var valDisplay = activeTier.formatted_card_value || formatMoney(activeTier.card_value);
            mobileText.innerHTML = 'You have unlocked the <span style="color:#FFD700;font-weight:bold;">' + valDisplay + ' Gift Card!</span>';
        }
    }
  };

  var addGiftCard = function(variantId) {
    if (isUpdating) return;
    isUpdating = true;
    CartJS.addItem(variantId, 1, { '_gift_card_promo': 'true' }, {
        "success": function(data, textStatus, jqXHR) {
            isUpdating = false;
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            isUpdating = false;
            log('Error adding gift card', errorThrown);
        }
    });
  };

  var swapGiftCard = function(oldItem, newVariantId) {
    if (isUpdating) return;
    isUpdating = true;

    var removeId = oldItem.key ? oldItem.key : oldItem.variant_id;
    // Chain the remove and add operations
    CartJS.removeItemById(removeId, {
        "success": function(data, textStatus, jqXHR) {
            log('Removed old card successfully');
            CartJS.addItem(newVariantId, 1, { '_gift_card_promo': 'true' }, {
                "success": function(data, textStatus, jqXHR) {
                    isUpdating = false;
                    log('Added new card successfully');
                },
                "error": function(jqXHR, textStatus, errorThrown) {
                    isUpdating = false;
                    log('Error adding new card', errorThrown);
                }
            });
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            // If removal fails, we abort the add to prevent duplicates?
            // Or should we try to add anyway? Safer to abort and maybe retry or let user manual fix.
            isUpdating = false;
            log('Error removing old card', errorThrown);
        }
    });
  };

  var removeGiftCard = function(item) {
     if (isUpdating) return;
     isUpdating = true;
     var removeId = item.key ? item.key : item.variant_id;
     CartJS.removeItemById(removeId, {
        "success": function(data, textStatus, jqXHR) {
            isUpdating = false;
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            isUpdating = false;
            log('Error removing card', errorThrown);
        }
     });
  };

  var handleCartChange = function() {
    // Check if we are in the middle of our own update
    if (isUpdating) {
        log('Skipping handleCartChange because isUpdating is true');
        return;
    }

    if (!config.enabled) return;
    // if (isUpdating) return; // Commented out to allow UI updates triggered from callbacks

    var subtotal = getCartSubtotal();
    var eligibleTier = getEligibleTier(subtotal);
    var currentCard = findGiftCardInCart();

    log('Subtotal:', subtotal, 'Eligible Tier:', eligibleTier, 'Current Card:', currentCard);

    if (eligibleTier) {
      if (currentCard) {
        if (String(currentCard.variant_id) === String(eligibleTier.variant_id)) {
          renderUI(eligibleTier, true, subtotal);
        } else {
          if (!isUpdating) {
             log('Swapping card', currentCard.variant_id, 'to', eligibleTier.variant_id);
             swapGiftCard(currentCard, eligibleTier.variant_id);
          }
        }
      } else {
        renderUI(eligibleTier, false, subtotal);
      }
    } else {
      if (currentCard) {
        if (currentCard.properties && currentCard.properties['_gift_card_promo'] === 'true') {
             if (!isUpdating) {
                 log('Removing card as no longer eligible');
                 removeGiftCard(currentCard);
             }
        } else {
            renderUI(null, false, subtotal);
        }
      } else {
        renderUI(null, false, subtotal);
      }
    }
  };

  return {
    init: init,
    handleCartChange: handleCartChange,
    addGiftCard: addGiftCard
  };
})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    GIFT_CARD_PROMO.init();
  });
} else {
  GIFT_CARD_PROMO.init();
}
